import React, { useEffect, useState } from "react";
import { Box, Button, CardContent, Paper, Table, TableBody, TableContainer } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import PageLayout from "../components/layout/PageLayout";
import { fetchTemplates, selectAllTemplates } from "../store/templateSlice";
import { useDispatch, useSelector } from "react-redux";
import Template from "../components/entry/Template";
import EditTemplateForm from "../components/form/EditTemplateForm";
import {useTranslation} from "react-i18next";

const TemplatesPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const templates = useSelector((state) => selectAllTemplates(state));
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    useEffect(() => {
        dispatch(fetchTemplates());
    }, [dispatch]);

    const onNewTemplateClick = () => {
        setSelectedTemplate({ description: "", type: "EXPENSE" });
    };

    const onTemplateClick = (template) => {
        setSelectedTemplate(template);
    };

    const clearSelection = () => {
        setSelectedTemplate(null);
    };

    return (
        <PageLayout title={t("pages.templates.title")}>
            <CardContent sx={{ minHeight: 200, maxHeight: "90%", overflowY: "auto" }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="templates table">
                        <TableBody>
                            {templates &&
                                templates.map((template) => (
                                    <Template
                                        key={template.id}
                                        template={template}
                                        onTemplateClick={onTemplateClick}
                                    />
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ height: 50 }} />
                <Button
                    style={{ position: "absolute", bottom: 30, right: "46%", fontSize: "4rem" }}
                    onClick={onNewTemplateClick}
                >
                    <AddCircle fontSize="inherit" />
                </Button>
            </CardContent>
            {selectedTemplate && (
                <EditTemplateForm template={selectedTemplate} onCancel={clearSelection} />
            )}
        </PageLayout>
    );
};

export default TemplatesPage;
